module.exports = __webpack_public_path__ + "static/media/nunito-sans-v6-latin-regular.9c6a1ff2.woff2";